<template>
  <section>
    <div
      id="details"
      class="campaigns-form"
    >
      <!-- Image -->
      <figure class="campaigns-form__image">
        <picture>
          <source
            media="--large"
            data-srcset="/static/images/banner.jpg,
            /static/images/banner@2x.jpg 2x, /static/images/banner@3x.jpg 3x"
          >

          <img
            class="lazyload"
            data-sizes="auto"
            data-src="/static/images/banner.jpg"
          >
        </picture>
      </figure>

      <!-- Icon (arrow) -->
      <div class="campaigns-form__icon">
        <i class="icon-arrow animation-jump" />
      </div>

      <div class="grid">
        <div class="col-8_md-6_sm-12">
          <!-- Bliss -->
          <router-link
            :to="{ name: 'home' }"
            active-class=""
            class="campaigns-form__bliss"
          >
            <i class="icon-bliss" />
          </router-link>

          <!-- Reel -->
          <div class="campaigns-form__reel">
            <div
              class="campaigns-form__reel__line"
            >
              {{ campaign.title }}
              <div class="underline">
                {{ campaign.titleUnderline }}
              </div>
            </div>
          </div>

          <!-- Video -->
          <div class="campaigns-form__video">
            <icon-play-view
              :loading="loadingVideo"
              :immediate="true"
              :invert="true"
              @click.native="clickFullscreen"
            />

            <video-fullscreen-view
              :video-id="videoId"
              :fullscreen="fullscreen"
              @close-fullscreen="fullscreen = false"
              @click-esc="fullscreen = false"
              @stop-loading="loadingVideo = false"
            />
          </div>

          <div class="campaigns-form__phone">
            <icon-phone-view>
              <a :href="getPhone(campaign.phone)">
                {{ campaign.phone }}
              </a>
            </icon-phone-view>
          </div>
        </div>

        <div class="col-4_md-6_sm-12">
          <div class="on-desktop">
            <!-- Title -->
            <div class="campaigns-form__title">
              {{ $t('project_8') }}
            </div>

            <!-- Subtitle -->
            <div class="campaigns-form__subtitle">
              {{ $t('project_9') }}
            </div>

            <form
              class="grid"
              @submit.prevent="submitContact"
            >
              <div class="col-12">
                <input-label-view
                  v-model="name"
                  label="contact_5"
                />
              </div>

              <div class="col-12">
                <input-label-view
                  v-model="email"
                  type="email"
                  label="contact_6"
                />
              </div>

              <div class="col-12">
                <input-label-view
                  v-model="phone"
                  type="tel"
                  label="contact_7"
                />
              </div>

              <div class="col-12">
                <input-text-view
                  v-model="message"
                  label="contact_8"
                />
              </div>

              <button-view
                type="submit"
                variant="full special"
              >
                {{ campaign.button }}
              </button-view>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="campaigns-form__fields on-phone">
      <!-- Title -->
      <div class="campaigns-form__title">
        {{ $t('project_8') }}
      </div>

      <!-- Subtitle -->
      <div class="campaigns-form__subtitle">
        {{ $t('project_9') }}
      </div>

      <form
        class="grid"
        @submit.prevent="submitContact"
      >
        <div class="col-12">
          <input-label-view
            v-model="name"
            label="contact_5"
          />
        </div>

        <div class="col-12">
          <input-label-view
            v-model="email"
            type="email"
            label="contact_6"
          />
        </div>

        <div class="col-12">
          <input-label-view
            v-model="phone"
            type="tel"
            label="contact_7"
          />
        </div>

        <div class="col-12">
          <input-text-view
            v-model="message"
            label="contact_8"
          />
        </div>

        <button-view
          type="submit"
          variant="full special"
        >
          {{ campaign.button }}
        </button-view>
      </form>
    </div>

    <!-- Message (success) -->
    <message-view :show="show">
      <!-- Title -->
      <template slot="title">
        {{ $t('message_3') }}
      </template>

      <!-- Message -->
      <template slot="message">
        {{ $t('message_4') }}
      </template>

      <!-- Action -->
      <template slot="action">
        <button-view
          type="submit"
          variant="center title"
          @click.native="show = false"
        >
          {{ $t('message_6') }}
        </button-view>
      </template>
    </message-view>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import campaigns from '@/mixins/campaigns';

export default {
  name: 'CampaignsForm',

  components: {
    VideoFullscreenView: () => import('@/components/video/video-fullscreen-view'),
    IconPhoneView: () => import('@/icons/icon-phone-view'),
    IconPlayView: () => import('@/icons/icon-phone-view'),
    InputLabelView: () => import('@/components/input/input-label-view'),
    InputTextView: () => import('@/components/input/input-text-view'),
    ButtonView: () => import('@/components/button/button-view'),
    MessageView: () => import('@/components/message/message-view')

  },

  mixins: [campaigns],

  data() {
    return {
      loading: false,
      show: false,

      name: '',
      email: '',
      phone: '',
      message: '',

      videoId: '214060797',
      loadingVideo: false,
      fullscreen: false
    };
  },

  methods: {
    ...mapActions('contact', [
      'submitContactForm'
    ]),

    async submitContact() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      try {
        await this.submitContactForm([
          this.name, this.email, this.phone, this.message
        ]);
      } finally {
        this.loading = false;
        this.show = true;
      }
    },

    clickFullscreen() {
      this.loadingVideo = true;
      this.fullscreen = true;
    },

    getPhone(phone) {
      return `tel:${phone}`;
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/campaigns/campaigns-form-view.scss"></style>



// WEBPACK FOOTER //
// campaigns-form-view.vue